<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div class="message-box">
      {{"CONFIRMDIALOG." + data?.message | translate}}
    </div>
  </div>
  <div class="dialog-footer">
    <div class="action-btns">
      <button class="w-link-btn" (click)="btnPress()" mat-dialog-close>{{'YES' | translate}}</button>
      <button class="w-link-btn cancel-btn" mat-dialog-close>{{'NO' | translate}}</button>
    </div>
  </div>
</div>

